import { getSetting } from "@src/utils/storage.utils";
import { jwtDecode } from "jwt-decode";

export type Presale = {
	eventId: number;
	name: string;
	preSaleCode: string;
	startDateTime: string;
	endDateTime: string;
	ticketLimit?: string;
};

export type Attractions = {
	eventId: number;
	name: string;
};

export type Event = {
	eventId?: number;
	legacyEventId?: string;
	eventName?: string;
	eventInfo?: string;
	venueName?: string;
	venueStreet?: string;
	venueCity?: string;
	venueStateCode?: string;
	venueCountryCode?: string;
	eventStartDateTime?: string;
	primaryEventUrl?: string;
	eventStatus?: string;
	eventScore?: number;
	eventScoreReason?: string;
	eventCategory?: string;
	salesInsightUrl?: string;
	ticketLimit?: string;
	presaleStartDateTime?: string;
	presaleCodes?: Array<string>;
	attractions?: Array<Attractions>;
	presales?: Array<Presale>;
};

export type TndResponse = {
	TmEventId: string | null;
	TndEventId: string | null;
	VividEventId: string | null;
	SfEventId: number | null;
	RequestedEventID: string | null;
};

export const PAGINATION_CONFIG = {
	MAX_VISIBLE_PAGES: 7,
	EDGE_PAGE_COUNT: 3,
	ELLIPSIS_THRESHOLD: 2,
	PAGE_RECORDS: 40,
};

export const EVENTLIST_URL = {
	HOST_URL: window?.location?.host,
	TND_URL: "https://www.eventprostickets.com/",
	UFLIP_URL: "https://buy.uflip.com/",
};

export const PRESALE_TAG = {
	UPCOMING: "Upcoming",
};

export const EVENT_SCORE_COLOR_RANGE = [
	{ min: 0, max: 69, color: "#A12020" }, // Dark Red
	{ min: 70, max: 74, color: "#D60D25" }, // Red
	{ min: 75, max: 79, color: "#F17C0A" }, // Orange
	{ min: 80, max: 84, color: "#E1D50F" }, // Yellow
	{ min: 85, max: 89, color: "#B2D140" }, // Yellow-Green
	{ min: 90, max: 94, color: "#8FCD6C" }, // Light Green
	{ min: 95, max: 100, color: "#006400" }, // Dark Green
];

export const getEnvironment = () => {
	const token = getSetting("token", "");
	let environment = "";
	try {
		const decoded = token ? jwtDecode<{ Environment: string }>(token) : null;
		environment = decoded?.Environment || "";
	} catch (error) {
		console.error("Failed to decode JWT token:", error);
	}
	return environment;
};
